// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"04369830","774":"f96d036c","787":"904982d8"}[chunkId] + ".chunk.js";
};